import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class LicensesBuyProductService {

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  validateSelectedFan(getFanDetailService, dcmCode, qty, fan) {
    const fanObj = {};
    var dcmArray = new Array();
    dcmArray.push(dcmCode);
    fanObj['dcmCodes'] = dcmArray;
    fanObj['quantity'] = qty;
    fanObj['fan'] = fan;
    return this.httpClientService.authorizedPost(getFanDetailService, fanObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  getBanDetailsGnFan(getBanDetailService, fan) {
    const fanObj = {};
    fanObj['fan'] = fan;
    return this.httpClientService.authorizedPost(getBanDetailService, fanObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  getCtnDetailsGnBan(getCtnDetailService, ban) {
    const banObj = {};
    banObj['ban'] = ban.name;
    return this.httpClientService.authorizedPost(getCtnDetailService, banObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  getCtnUniqueValidate(companyId, ctnValidateUrl, licensesBuyProductModel) {
    ctnValidateUrl = this.httpClientService.replaceTextInUrl('{companyid}', companyId, ctnValidateUrl);
    return this.httpClientService.authorizedPut(ctnValidateUrl, licensesBuyProductModel)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }

  // Page Load
  createPageLoadProperties(dcmCode: string, url: string, pageTitle: string) {
    let dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = pageTitle;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_INCREASE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = dcmCode;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}
